export const ROOT = "/";
export const PRICING = "/pricing";
export const WELCOME = "/welcome";
export const WELCOME_TOOL_SPEC = "/welcome/:toolSlug";

export const AUTHENTICATE = "/authenticate"; // Login route
export const AUTHENTICATE_RESET_PASSWORD = "/authenticate/reset-password";
export const AUTHENTICATE_SIGNUP = "/authenticate/signup";
export const LOGOUT = "/logout";

export const AUTHENTICATE_LOGIN = "/authenticate/login";
export const LOGIN = "/login";

// Tools
export const WRITING_WIZARD = "/writing-wizard";
export const LESSON_LAB = "/lesson-lab";
export const RESEARCHER = "/researcher";
export const RESOURCE_REFINERY = "/resource-refinery";
export const CATCHUP_COACH = "/catchup-coach";

// Legacy tool redirects
export const COMMUNICATIONS_GENERATOR = "/communications-generator";
export const RESOURCE_CUSTOMISER = "/resource-customiser";

export const SETTINGS = "/settings";
export const SETTINGS_TEMPLATES = "/settings/templates";
export const SETTINGS_SUBSCRIPTION = "/settings/subscription";
export const SETTINGS_INVOICES = "/settings/invoices";
export const SETTINGS_CHANGE_PASSWORD = "/settings/change-password";
export const SETTINGS_LANGUAGE_COMPLETION = "/settings/language-completion";

export const CHECKOUT = "/checkout";
export const CHECKOUT_RETURN = "/checkout/return";
export const VERIFY = "/verify";
export const RESET_PASSWORD = "/reset-password";
export const PRIVACY_POLICY = "/privacy-policy";
export const TERMS_OF_SERVICE = "/terms-of-service";
export const SITEMAP = "/sitemap";
export const FAQ = "/faq";
export const ABOUT = "/about";
export const CONTACT = "/contact";
export const DOCS = "/docs";
export const SUPPORT = "/support";
export const ACCESSIBILITY = "/accessibility";

// Dynamic builders (encode params and omit when not needed)
export function AUTHENTICATE__DYNAMIC(returnTo?: string) {
  return returnTo && returnTo !== "/"
    ? `${AUTHENTICATE}?returnTo=${encodeURIComponent(returnTo)}`
    : AUTHENTICATE;
}

export function AUTHENTICATE_RESET_PASSWORD__DYNAMIC(returnTo?: string) {
  return returnTo && returnTo !== "/"
    ? `${AUTHENTICATE_RESET_PASSWORD}?returnTo=${encodeURIComponent(returnTo)}`
    : AUTHENTICATE_RESET_PASSWORD;
}

export function AUTHENTICATE_SIGNUP__DYNAMIC(returnTo?: string) {
  return returnTo && returnTo !== "/"
    ? `${AUTHENTICATE_SIGNUP}?returnTo=${encodeURIComponent(returnTo)}`
    : AUTHENTICATE_SIGNUP;
}
